export default __webpack_public_path__ + "static/media/paypal_logo.01ecbe9d.png";